/**
 * edital.ts — Edital competitivo: documento gerado, edição e geração
 * consolidando a cadeia DFD+ETP+TR (fase Edital).
 */

import type { components } from './generated/api'
import { api } from './http'

export type DocumentoEdital = components['schemas']['DocumentoEdital']
export type SecaoEdital = components['schemas']['SecaoEdital']
export type FormularioEdital = components['schemas']['FormularioEdital']
export type NovoEdital = components['schemas']['NovoEdital']
export type ParametrosEdital = components['schemas']['ParametrosEditalInput']
export type GeracaoEdital = components['schemas']['GeracaoEdital']

export function documentoEdital(id: number) {
  return api<DocumentoEdital>(`/api/v1/edital/${id}`)
}

export function formularioEdital(id: number) {
  return api<FormularioEdital>(`/api/v1/edital/${id}/formulario`)
}

export function salvarEdital(id: number, secoes: Record<string, string>) {
  return api<DocumentoEdital>(`/api/v1/edital/${id}`, {
    method: 'PUT',
    body: { id, secoes },
  })
}

export function excluirEdital(id: number) {
  return api<{ excluido: boolean }>(`/api/v1/edital/${id}`, { method: 'DELETE' })
}

export function novoEdital(id: number) {
  return api<NovoEdital>(`/api/v1/edital/${id}/novo`)
}

export function gerarEdital(id: number, parametros: ParametrosEdital) {
  return api<GeracaoEdital>(`/api/v1/edital/${id}/gerar`, {
    method: 'POST',
    body: parametros,
  })
}
